import styled from 'styled-components'

import { Button } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp12};
`

export const BlocksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp12};
`

export const BlockButtonWrapper = styled.span`
  display: flex;
`

export const BlockButton = styled(Button)`
  justify-content: flex-start;
`
